import { Modal } from "@mui/material";
import { ModalBox } from "@components/admin/StyledComponents";
import MyAvatar from "@components/admin/MyAvatar";
import DetailRow from "@components/admin/DetailRow";
import { useEffect, useState } from "react";
import api from "@apiClient";
import { toast } from "react-toastify";
import { Button } from "@hooks/useActionFilters";

export default function FeedbackResponse({ feedback, setFeedback }) {
  const [open, setOpen] = useState(false);
  const user = feedback?.user;
  const [response, setResponse] = useState("");
  const respondToFeedback = () => {
    if (!response.trim()) {
      toast.error("Enter Feedback before submitting.");
      return;
    }
    api
      .respondToFeedback({ id: feedback.id, response })
      .then(() => {
        setFeedback(null);
        setOpen(false);
        toast.success("Response Sent Successfully");
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (feedback) setOpen(true);
  }, [feedback]);
  if (!feedback) return <div></div>;
  return (
    <Modal
      open={open}
      onClose={() => {
        setFeedback(null);
        setOpen(false);
      }}
    >
      <ModalBox className="shadow-md overflow-auto">
        <div className="flex gap-6">
          <MyAvatar
            src={user?.media?.currBucketUrl}
            name={user?.firstName + " " + user?.lastName}
            subtext={`@${user?.userName}`}
            textProps={{ className: "font-bold text-gray-600" }}
          />
        </div>
        <div>
          <table className="w-full text-left text-sm mt-5">
            <tbody>
              <DetailRow label="Email:" value={user?.emailAddress} />
              <DetailRow label="Feedback Message:" value={feedback?.detail} />
              <DetailRow label="Feedback Reply:" value={""} />
            </tbody>
          </table>

          <textarea
            className="border-gray-200 border-2 rounded-md mt-5 w-1/2 p-2"
            rows={6}
            onChange={(e) => setResponse(e.target.value)}
          />
          <div className="flex gap-2 mt-8 justify-end ">
            <Button variant="contained" onClick={respondToFeedback}>
              Send
            </Button>
          </div>
        </div>
      </ModalBox>
    </Modal>
  );
}
